// Kaizen Dashboard base styles
import colors from "assets/theme/base/colors";

// Kaizen Dashboard helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { transparent } = colors;
const { inputColors } = colors;

const select = {
  styleOverrides: {
    root: {
      "&.Mui-focused": {
        border: `3.5px solid ${inputColors.borderColor.focus}`,
      },
    },
    select: {
      display: "grid",
      alignItems: "center",
      padding: `0 ${pxToRem(12)} !important`,

      "& .Mui-selected": {
        backgroundColor: transparent.main,
      },
      minWidth: "100%",
    },

    selectMenu: {
      background: "none",
      height: "none",
      minHeight: "none",
      overflow: "unset",
    },
  },
};

export default select;
